import type { DocPageContent } from '../docs-content'

const page = {
  order: 23,
  slug: 'reference',
  title: '参考',
  description: '支持的格式、术语、控件、预检信息和词汇表。',
  category: '参考',
  sections: [
    {
      title: '格式参考',
      items: [
        '导入类别包括视频、音频、图片、GIF、SVG、生成的素材和复合片段。',
        '导出容器格式包括 MP4、MOV、WebM 和 MKV。',
        '音频导出格式包括 MP3、AAC 和 WAV。',
        '编码器支持取决于浏览器的解码和编码能力。',
      ],
    },
    {
      title: '编辑器词汇表',
      items: [
        '波纹编辑：通过移动后续素材来关闭或打开时间线空间的编辑方式。',
        '滚动编辑：在两个相邻片段之间移动剪切点的编辑方式。',
        '滑移编辑：在不移动片段的情况下改变片段内部源时间的编辑方式。',
        '滑行编辑：移动片段同时调整相邻剪切点的编辑方式。',
        '入/出范围：用于源或导出范围的标记起始和结束点。',
        '代理：为更流畅的预览播放而生成的轻量级媒体。',
      ],
    },
    {
      title: '功能词汇表',
      items: [
        'LUT：用于色彩变换的查找表。',
        '关键帧：在特定时间点的值，用于对属性进行动画处理。',
        '复合片段：分组的时间线内容，表示为可复用的媒体。',
        '调整层：其特效应用于下方项目的视觉层。',
        '渲染队列：保存到工作区的有序导出列表。',
        '预检：渲染开始前的导出就绪检查。',
      ],
    },
  ],
} satisfies DocPageContent

export default page